export default "__VITE_ASSET__9220bb59__"